import { ImPhone } from 'react-icons/im'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { SiWhatsapp, SiInstagram, SiFacebook } from 'react-icons/si'
import moment from 'moment';

import { Container, Content, DayOfWeek, ContentCoupons } from './style';

export function ModalBusinessInformations({ open, closeModal }) {

    function verifyingWorkingTime(timeOpen, timeClose, text) { 
        return timeOpen !== '' ? `${text} ${timeOpen} a ${timeClose}`
        :
        `${text} - Fechado`
    }

    const monday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openMon'), 
        localStorage.getItem('@Inoveclube:closeMon'), 
        'SEG'
    )

    const tuesday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openTue'), 
        localStorage.getItem('@Inoveclube:closeTue'), 
        'TER'
    )

    const wednesday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openWed'), 
        localStorage.getItem('@Inoveclube:closeWed'), 
        'QUA'
    )

    const thursday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openThu'), 
        localStorage.getItem('@Inoveclube:closeThu'), 
        'QUI'
    )

    const friday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openFri'), 
        localStorage.getItem('@Inoveclube:closeFri'), 
        'SEX'
    )

    const saturday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openSat'), 
        localStorage.getItem('@Inoveclube:closeSat'), 
        'SAB'
    )

    const sunday = verifyingWorkingTime(
        localStorage.getItem('@Inoveclube:openSun'), 
        localStorage.getItem('@Inoveclube:closeSun'), 
        'DOM'
    )


    return(
        <Container open={open}>
            <Content color={localStorage.getItem('@Inoveclube:colorButton')}>
                <span onClick={() => closeModal(false)}>
                    &#10006;
                </span>

                <a 
                    href={"tel:" + localStorage.getItem('@Inoveclube:numberBusiness')}
                    className="linkInfo"
                >
                    <p>
                        <ImPhone /> {localStorage.getItem('@Inoveclube:numberBusiness')}
                    </p>
                </a>

                <a 
                    href={localStorage.getItem('@Inoveclube:maps')} 
                    className="linkInfo"
                    target="_blank" 
                    rel="noreferrer"
                >
                    <p>
                        <FaMapMarkerAlt /> {localStorage.getItem('@Inoveclube:street')}
                    </p>
                </a>    


                <h4>Horário de funcionamento</h4>
                <ContentCoupons>
                    <DayOfWeek
                        active={moment().isoWeekday() === 1}
                    >
                        <p>{monday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 2}
                    >
                        <p>{tuesday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 3}
                    >
                        <p>{wednesday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 4}
                    >
                        <p>{thursday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 5}
                    >
                        <p>{friday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 6}
                    >
                        <p>{saturday}</p>
                    </DayOfWeek>

                    <DayOfWeek
                        active={moment().isoWeekday() === 7}
                    >
                        <p>{sunday}</p>
                    </DayOfWeek>
                </ContentCoupons>
              

                <div className="socialMedias">
                    <a 
                        href={`https://api.whatsapp.com/send?phone=+55${JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.whatsapp}`}
                        style={{display: JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.whatsapp !== '' ? '' : 'none'}}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <SiWhatsapp />
                    </a>
                   
                    <a 
                        href={`https://www.instagram.com/${JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.instagram}/`}
                        style={{display: JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.instagram !== '' ? '' : 'none'}}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <SiInstagram />
                    </a>

                    <a
                        href={`https://www.facebook.com/${JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.facebook}`}
                        style={{display: JSON.parse(localStorage.getItem('@Inoveclube:socialMedias'))?.facebook !== '' ? '' : 'none'}}
                        target="_blank"
                        rel="noreferrer"
                    >
                        <SiFacebook />
                    </a>

                </div>
            </Content>
        </Container>
    )
}
